/**
 * 绿色的物流标
 */
import React from 'react';
import PropTypes from 'prop-types';
import * as I18n from 'src/utils/i18n';
import './shipping.scss';

const PromotionShippingTag = ({ type, style }) => {
  const textMap = {
    gd: I18n.get('mobile_product_on_time_delivery_tip') || 'On-time delivery',
    s40: I18n.get('mobile_product_logistics_up_40_tip') || 'Save $40 off',
    s100: I18n.get('mobile_product_logistics_up_100_tip') || 'Save $100 off',
  };

  return (
    <span className="right-action__promotion-shipping-tag" style={style}>
      {textMap[type]}
    </span>
  );
};
PromotionShippingTag.propTypes = {
  type: PropTypes.oneOf(['gd', 's40', 's100']),
};

export default PromotionShippingTag;
